module.exports = __webpack_public_path__ + "static/banner-tablet-919b81116111caf4690c07b099e5d208.png";